(() => {
  const config = document.getElementById('lcvr-tab-alert');
  if (!config || config.dataset.initialized || !('visibilityState' in document)) return;
  const messages = [config.dataset.first, config.dataset.second, config.dataset.third].filter(Boolean);
  if (!messages.length) return;
  config.dataset.initialized = 'true';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let hasBeenVisible = document.visibilityState === 'visible';
  let suspended = false;
  let active = false;
  let timer = 0;
  let originalTitle = '';
  let lastTitle = '';
  let originalIcons = [];
  let addedIcon = null;
  let frames = null;
  let frameIndex = 0;
  let startedAt = 0;

  function recordFrames() {
    if (frames !== null) return frames;
    frames = [];
    try {
      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = 64;
      const ctx = canvas.getContext('2d');
      if (!ctx) return frames;
      for (let frame = 0; frame < 8; frame += 1) {
        ctx.clearRect(0, 0, 64, 64);
        ctx.save();
        ctx.translate(32, 32);
        ctx.rotate(frame * Math.PI / 4);
        ctx.beginPath();
        ctx.arc(0, 0, 29, 0, Math.PI * 2);
        ctx.fillStyle = '#101410';
        ctx.fill();
        const colors = ['#f36b61', '#e4d04b', '#45be88'];
        colors.forEach((color, index) => {
          ctx.beginPath();
          ctx.arc(0, 0, 29, index * Math.PI * 2 / 3, (index + 1) * Math.PI * 2 / 3);
          ctx.strokeStyle = color;
          ctx.lineWidth = 4;
          ctx.stroke();
        });
        ctx.strokeStyle = '#667063';
        ctx.lineWidth = 1;
        for (const radius of [16, 20, 24]) {
          ctx.beginPath();
          ctx.arc(0, 0, radius, 0, Math.PI * 2);
          ctx.stroke();
        }
        ctx.beginPath();
        ctx.arc(0, 0, 24, -0.7, -0.1);
        ctx.strokeStyle = '#f7f7dd';
        ctx.lineWidth = 3;
        ctx.stroke();
        ctx.save();
        ctx.beginPath();
        ctx.arc(0, 0, 11, 0, Math.PI * 2);
        ctx.clip();
        colors.forEach((color, index) => {
          ctx.fillStyle = color;
          ctx.fillRect(-11, -11 + index * 22 / 3, 22, 22 / 3 + 1);
        });
        ctx.restore();
        ctx.beginPath();
        ctx.arc(0, 0, 2.5, 0, Math.PI * 2);
        ctx.fillStyle = '#101410';
        ctx.fill();
        ctx.restore();
        frames.push(canvas.toDataURL('image/png'));
      }
    } catch {
      frames = [];
    }
    return frames;
  }

  function setTitle(title) {
    if (lastTitle && document.title !== lastTitle) originalTitle = document.title;
    document.title = title;
    lastTitle = title;
  }

  function showIcon(index) {
    const icons = recordFrames();
    if (!icons.length) return;
    for (const saved of originalIcons) {
      saved.node.setAttribute('href', icons[index % icons.length]);
      saved.node.setAttribute('type', 'image/png');
      saved.node.setAttribute('sizes', '64x64');
    }
    if (addedIcon) addedIcon.href = icons[index % icons.length];
  }

  function stop() {
    window.clearTimeout(timer);
    timer = 0;
    if (!active) return;
    if (document.title === lastTitle) document.title = originalTitle;
    for (const saved of originalIcons) {
      for (const attribute of ['href', 'type', 'sizes']) {
        if (saved[attribute] === null) saved.node.removeAttribute(attribute);
        else saved.node.setAttribute(attribute, saved[attribute]);
      }
    }
    if (addedIcon) addedIcon.remove();
    originalIcons = [];
    addedIcon = null;
    active = false;
    lastTitle = '';
  }

  function tick() {
    timer = 0;
    if (!active || suspended || document.visibilityState !== 'hidden') {
      stop();
      return;
    }
    const messageIndex = Math.floor((performance.now() - startedAt) / 2000) % messages.length;
    setTitle(messages[messageIndex]);
    frameIndex += 1;
    showIcon(frameIndex);
    timer = window.setTimeout(tick, 500);
  }

  function start() {
    if (active || suspended || !hasBeenVisible) return;
    originalTitle = document.title;
    originalIcons = Array.from(document.querySelectorAll('link[rel~="icon"]'), node => ({
      node,
      href: node.getAttribute('href'),
      type: node.getAttribute('type'),
      sizes: node.getAttribute('sizes')
    }));
    if (!originalIcons.length && recordFrames().length) {
      addedIcon = document.createElement('link');
      addedIcon.rel = 'icon';
      addedIcon.type = 'image/png';
      addedIcon.sizes = '64x64';
      document.head.append(addedIcon);
    }
    active = true;
    startedAt = performance.now();
    frameIndex = 0;
    setTitle(messages[0]);
    showIcon(0);
    if (!reducedMotion.matches) timer = window.setTimeout(tick, 500);
  }

  function reconcile() {
    if (document.visibilityState === 'visible') {
      hasBeenVisible = true;
      stop();
    } else if (document.visibilityState === 'hidden') start();
  }

  document.addEventListener('visibilitychange', reconcile);
  window.addEventListener('pagehide', () => {
    suspended = true;
    stop();
  });
  window.addEventListener('pageshow', () => {
    suspended = false;
    reconcile();
  });
  reducedMotion.addEventListener('change', () => {
    stop();
    reconcile();
  });
})();
